import React, { useState, useEffect } from 'react';
import { Translate, Translator } from 'react-translated';
import { bytesToSize } from '../../helpers/fileHelpers';

import Form from 'react-bootstrap/Form';
import DocLink from '../misc/DocLink';
import UploadAttachmentALTP from './UploadAttachmentALTP';
function AttachmentsALTP(props) {
	const {
		title,
		titleBefore,
		documentType,
		validated,
		required,
		data,
		additionalField,
		readOnly
	} = props;
	const {
		DOC_MAX_QUANTITY,
		DOC_MAX_TOTAL_FILESIZE
	} = require('../../config/constants');

	if (!documentType || !data) {
		return null;
	}

	const [uploads, setUploads] = useState([{ documentType: documentType }]);
	const [hasTotalFilesizeError, setHasTotalFilesizeError] = useState(false);

	const totalFilesizeString = bytesToSize(DOC_MAX_TOTAL_FILESIZE);
	const totalFilesizeError = `Total filesize exceeds the ${totalFilesizeString} limit.`;

	useEffect(() => {
		if (data) {
			let currentUploads = [data];
			if (currentUploads.length) {
				setUploads(currentUploads);
			} else {
				setUploads([{ documentType: documentType }]);
			}
		}
	}, [data]);

	const handleAttachmentChanges = (updatedFiles) => {
		let filesizeError = false;
		const filesizeSum = updatedFiles.reduce((accumulator, object) => {
			if (object.filesize) {
				return accumulator + object.filesize;
			}

			return accumulator;
		}, 0);

		if (filesizeSum > DOC_MAX_TOTAL_FILESIZE) {
			filesizeError = true;
		} else {
			filesizeError = false;
		}

		setHasTotalFilesizeError(filesizeError);

		if (props.handleUpdateAttachments) {
			props.handleUpdateAttachments(updatedFiles);
		}

		if (props.handleCheckTotalFilesize) {
			props.handleCheckTotalFilesize(filesizeError);
		}
	};

	return (
		<>
			<Form.Group className={`form-custom-file ${(additionalField) ? 'form-custom-file--additional-field' : ''} repeater`}>
				{ title &&
					<div>
						<h4>
							{ titleBefore }
							{ title }
						</h4>
					</div>
				}

				{ !readOnly &&
					<>
						{ uploads.map((item, index) => {
							const key = item.id || item.tempId;

							return (
								<div className="upload-item repeater-item" key={ key || index }>
									<UploadAttachmentALTP
										item={ item }
										index={ index }
										validated={ validated }
										required={ required }
										documentType={ documentType }
										title={ title }
										data={ data }
										hasTotalFilesizeError={ hasTotalFilesizeError }
										additionalField={ additionalField }
										handleUpdateAttachments={(data) => { handleAttachmentChanges(data); }}
									/>
								</div>
							);
						})}

						<div className="upload-controls repeater-controls">
							{ hasTotalFilesizeError &&
								<div className="upload-controls__feedback">
									<div className="invalid-feedback show error-attachment-upload-feedback">
										<Translate text={ totalFilesizeError } />
									</div>
								</div>
							}
						</div>
					</>
				}

				{ (readOnly && Array.isArray(uploads) && uploads.length > 0) &&
					<div className="post-tender__docs">
						{ uploads.map((item, index) => {
							return (
								<div className="post-tender__docs-item" key={ index }>
									{ item.filename &&
										<DocLink
											key={ index }
											data={ item }
										/>
									}
								</div>
							);
						})}
					</div>
				}
			</Form.Group>
		</>
	);
}

export default AttachmentsALTP;
